var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMopusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 136,
    viewBox: "0 0 381 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.24 66.4401L380.81 55.87H368.75V34.65L366.81 36.8L352.19 52.99L336.79 35.85L335.68 34.62V55.87H246.68L215.86 33.65V55.86H125.86L118.75 44.59H99.97L93.21 55.59V55.9H80L92.94 36.01H93.21V0.0100098H57.42L46.66 11.51L35.72 0.0100098H0.0200195V135.65H301.06L320.71 116H253.58V103.56H305.86L313.28 96.25H253.58V66.47L370.24 66.4401ZM18 18H28L46.77 37.73L65.23 18H75.23V55.87H63.17V34.65L46.55 53.02L30.06 34.65V55.9H18V18ZM94 116H22.74V87.47H39.56V103.56H77.19V78.9H22.75V66.47H94.01L94 116ZM168.82 85.0701C168.975 88.0143 168.046 90.9133 166.21 93.22C164.577 95.1646 162.474 96.6588 160.1 97.5601C158.152 98.3473 156.08 98.7872 153.98 98.86H122.32V116H105.5V87H152V79H105.5V66.5701H154.5C156.401 66.4997 158.296 66.8261 160.065 67.5286C161.833 68.231 163.435 69.2941 164.77 70.65C166.071 71.9311 167.102 73.4604 167.801 75.1472C168.5 76.8341 168.853 78.644 168.84 80.47L168.82 85.0701ZM242.09 115.97H176.68V66.4401H193.5V103.53H225.27V66.4401H242.09V115.97Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 55.56V55.87H93L93.19 55.56Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 80.4401V85.04C168.995 87.9843 168.066 90.8833 166.23 93.1901C164.597 95.1347 162.494 96.6287 160.12 97.53C158.172 98.3173 156.1 98.7573 154 98.8301H122.34V115.97H105.52V86.97H152.02V78.97H105.52V66.54H154.52C156.42 66.4764 158.313 66.8089 160.077 67.5165C161.842 68.2241 163.44 69.2912 164.77 70.65C166.068 71.9276 167.096 73.452 167.795 75.1334C168.494 76.8148 168.849 78.6192 168.84 80.4401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09 66.44V115.97H176.68V66.44H193.5V103.53H225.27V66.44H242.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19 81.49L351.54 85.14H269.36V78.87H330.52L327.75 81.49H355.19Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 81.49L330.52 78.87H269.36V85.14H351.54L320.71 115.97H253.58V103.53H305.86L313.28 96.22H253.58V66.44H370.24L355.19 81.49H327.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.02 66.44V115.97H22.76V87.44H39.58V103.53H77.2V78.87H22.76V66.44H94.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.19 18V55.87H63.13V34.62L46.51 52.99L30.06 34.62V55.87H18V18H27.98L46.75 37.73L65.21 18H75.19Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19 55.56V55.87H93L93.19 55.56Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19 18L46.73 37.73L27.96 18H17.96V55.87H30.02V34.65L46.47 53.02L63.09 34.65V55.9H75.19V18.03L65.19 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81 55.87H125.84L118.73 44.6H99.95L93.19 55.56L93 55.87H79.98L92.92 35.98H113.77L110.1 30.14H96.68L104.59 18H115.13L139.81 55.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25 29.5V18H144.61V55.87H195.25V33.65H167.85V41.4H183.19V46.4H156.67V27.55H183.11V29.55L195.25 29.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.04 18V55.87H246.69L215.86 33.66V55.87H204.04V18H213.38L244.22 40.13V18H256.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.97 18V46.36H277.69V18H264.83V55.87H314.83V18H301.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.81 18V55.87H368.75V34.62L366.81 36.77L352.14 52.99L336.79 35.85L335.68 34.62V55.87H323.62V18H333.6L352.38 37.73L370.83 18H380.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19 18L46.73 37.73L27.96 18H17.96V55.87H30.02V34.65L46.47 53.02L63.09 34.65V55.9H75.19V18.03L65.19 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19 18L46.73 37.73L27.96 18H17.96V55.87H30.02V34.65L46.47 53.02L63.09 34.65V55.9H75.19V18.03L65.19 18Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380.81,
    height: 135.62,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMopusLogo);
export default __webpack_public_path__ + "static/media/mopus-logo.86b42bd56e65e6180d6e661ef2f3097e.svg";
export { ForwardRef as ReactComponent };